/* ============================================================
   Donglai · shared theme JS
   - Reveal-on-scroll observer (any element with .reveal)
   - Bracelet SVG bead generator (fills any <g data-dl-bracelet>)
   - Wu Xing selector interactivity
   ============================================================ */
(function () {
  'use strict';

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  function observeReveals(root) {
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- bracelet bead recipes ----------
     Each palette has gradients a/b (primary beads) and c (focal/contrast).
     The recipe below is the ordered list of which gradient each bead uses
     around the ring. Shared across palettes so all bracelets read as the
     same "style" in different colourways.
  ------------------------------------------------ */
  var BEAD_RECIPES = {
    amethyst: ['c','a','b','a','b','a','b','a','c','c','a','b','a','b','a','b'],
    southred: ['a','b','a','b','a','c','a','b','a','b','c','a','b','a'],
    jade:     ['a','b','a','c','a','b','a','c','a','b','a','c','a','b']
  };

  function placeBead(g, cx, cy, r, angleRad, radius, fillId) {
    var x = cx + Math.cos(angleRad) * r;
    var y = cy + Math.sin(angleRad) * r;

    var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('cx', x.toFixed(2));
    c.setAttribute('cy', y.toFixed(2));
    c.setAttribute('r', radius);
    c.setAttribute('fill', 'url(#' + fillId + ')');
    g.appendChild(c);

    var h = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
    h.setAttribute('cx', (x - radius * 0.32).toFixed(2));
    h.setAttribute('cy', (y - radius * 0.42).toFixed(2));
    h.setAttribute('rx', (radius * 0.30).toFixed(2));
    h.setAttribute('ry', (radius * 0.18).toFixed(2));
    h.setAttribute('fill', 'rgba(255,255,255,0.55)');
    h.setAttribute('transform', 'rotate(-25 ' + x + ' ' + y + ')');
    g.appendChild(h);
  }

  function initBracelets(root) {
    (root || document).querySelectorAll('g[data-dl-bracelet]').forEach(function (g) {
      if (g.childNodes.length > 0) return; /* already built */
      var palette = g.dataset.palette || 'amethyst';
      var uid = g.dataset.uid || palette;
      var recipe = BEAD_RECIPES[palette] || BEAD_RECIPES.amethyst;
      var N = recipe.length;
      var cx = 100, cy = 100, r = 78;
      for (var i = 0; i < N; i++) {
        var angle = -Math.PI / 2 + (i / N) * Math.PI * 2;
        var letter = recipe[i];
        var size = letter === 'c' ? 15 : (i % 2 === 0 ? 13 : 12);
        var fillId = 'dl-g-' + uid + '-' + letter;
        placeBead(g, cx, cy, r, angle, size, fillId);
      }
    });
  }

  /* ---------- wuxing selector ---------- */
  function initWuxing(root) {
    (root || document).querySelectorAll('.dl-wuxing').forEach(function (section) {
      if (section.dataset.dlWuxingReady === '1') return;
      section.dataset.dlWuxingReady = '1';

      var buttons = section.querySelectorAll('.dl-wuxing__btn');
      var panels  = section.querySelectorAll('[data-el-panel]');

      function activate(el, persist) {
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.el === el);
          b.setAttribute('aria-pressed', b.dataset.el === el ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.dataset.elPanel !== el;
        });
        if (persist) section.dataset.selected = el;
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () { activate(btn.dataset.el, true); });
        btn.addEventListener('mouseenter', function () { activate(btn.dataset.el, false); });
      });
      section.addEventListener('mouseleave', function () {
        if (section.dataset.selected) activate(section.dataset.selected, false);
      });

      var initial = section.dataset.selected || (buttons[0] && buttons[0].dataset.el);
      if (initial) activate(initial, true);
    });
  }

  /* ---------- zodiac luopan ---------- */

  var DL_ZODIAC_DATA = [
    { key:'rat',     cn:'鼠', branch:'子', hours:'23–01' },
    { key:'ox',      cn:'牛', branch:'丑', hours:'01–03' },
    { key:'tiger',   cn:'虎', branch:'寅', hours:'03–05' },
    { key:'rabbit',  cn:'兔', branch:'卯', hours:'05–07' },
    { key:'dragon',  cn:'龙', branch:'辰', hours:'07–09' },
    { key:'snake',   cn:'蛇', branch:'巳', hours:'09–11' },
    { key:'horse',   cn:'马', branch:'午', hours:'11–13' },
    { key:'goat',    cn:'羊', branch:'未', hours:'13–15' },
    { key:'monkey',  cn:'猴', branch:'申', hours:'15–17' },
    { key:'rooster', cn:'鸡', branch:'酉', hours:'17–19' },
    { key:'dog',     cn:'狗', branch:'戌', hours:'19–21' },
    { key:'pig',     cn:'猪', branch:'亥', hours:'21–23' }
  ];

  function dlZodiacYearToKey(year) {
    var idx = ((year - 4) % 12 + 12) % 12;
    return DL_ZODIAC_DATA[idx].key;
  }

  function dlZodiacPol(angleDeg, r) {
    var a = (angleDeg - 90) * Math.PI / 180;
    return { x: 50 + r * Math.cos(a), y: 50 + r * Math.sin(a) };
  }

  function buildLuopanFace(wheel) {
    var ns = 'http://www.w3.org/2000/svg';
    var spokes  = wheel.querySelector('[data-zodiac-spokes]');
    var branchG = wheel.querySelector('[data-zodiac-branches]');
    var hourG   = wheel.querySelector('[data-zodiac-hours]');
    var ticks   = wheel.querySelector('[data-zodiac-ticks]');
    if (!spokes || !branchG || !hourG || !ticks) return;

    DL_ZODIAC_DATA.forEach(function (z, i) {
      var angle = i * 30;
      var inner = dlZodiacPol(angle + 15, 14), outer = dlZodiacPol(angle + 15, 46);
      var ln = document.createElementNS(ns, 'line');
      ln.setAttribute('x1', inner.x); ln.setAttribute('y1', inner.y);
      ln.setAttribute('x2', outer.x); ln.setAttribute('y2', outer.y);
      spokes.appendChild(ln);

      var bp = dlZodiacPol(angle, 28);
      var bt = document.createElementNS(ns, 'text');
      bt.setAttribute('x', bp.x); bt.setAttribute('y', bp.y + 1.3);
      bt.setAttribute('text-anchor', 'middle');
      bt.textContent = z.branch;
      branchG.appendChild(bt);

      var hp = dlZodiacPol(angle, 19);
      var ht = document.createElementNS(ns, 'text');
      ht.setAttribute('x', hp.x); ht.setAttribute('y', hp.y + 1);
      ht.setAttribute('text-anchor', 'middle');
      ht.textContent = z.hours;
      hourG.appendChild(ht);

      for (var k = 0; k < 5; k++) {
        var a = angle + k * 6;
        var p1 = dlZodiacPol(a, 49.6), p2 = dlZodiacPol(a, k === 0 ? 47.5 : 48.6);
        var tk = document.createElementNS(ns, 'line');
        tk.setAttribute('x1', p1.x); tk.setAttribute('y1', p1.y);
        tk.setAttribute('x2', p2.x); tk.setAttribute('y2', p2.y);
        tk.setAttribute('stroke-width', k === 0 ? '.4' : '.15');
        tk.setAttribute('opacity',      k === 0 ? '.85' : '.45');
        ticks.appendChild(tk);
      }
    });
  }

  function initZodiacLuopan(root) {
    (root || document).querySelectorAll('[data-dl-zodiac]').forEach(function (section) {
      if (section.dataset.dlZodiacReady === '1') return;
      section.dataset.dlZodiacReady = '1';

      var wheel   = section.querySelector('[data-zodiac-wheel]');
      var buttons = section.querySelectorAll('[data-zodiac-key]');
      var panels  = section.querySelectorAll('[data-zodiac-panel]');
      var rails   = section.querySelectorAll('[data-zodiac-rail]');
      var needle  = section.querySelector('[data-zodiac-needle]');
      var trine   = section.querySelector('[data-zodiac-trine]');
      var clash   = section.querySelector('[data-zodiac-clash]');
      var yearInput = section.querySelector('[data-zodiac-year-input]');
      var readout   = section.querySelector('[data-zodiac-readout]');
      var railHead  = section.querySelector('[data-zodiac-rail-heading]');
      var defaultKey = section.dataset.defaultSign || 'horse';

      if (wheel) buildLuopanFace(wheel);

      function persistKey(key) {
        try { localStorage.setItem('dl_zodiac_key', key); } catch (_) {}
      }
      function getStoredKey() {
        try { return localStorage.getItem('dl_zodiac_key'); } catch (_) { return null; }
      }

      function activate(key, yearValue, opts) {
        var idx = DL_ZODIAC_DATA.findIndex(function (z) { return z.key === key; });
        if (idx === -1) return;

        buttons.forEach(function (btn) {
          var on = btn.getAttribute('data-zodiac-key') === key;
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-zodiac-panel') !== key; });
        rails.forEach(function  (r) { r.hidden = r.getAttribute('data-zodiac-rail')  !== key; });
        if (railHead) railHead.hidden = false;
        if (needle)   needle.style.transform = 'rotate(' + (idx * 30) + 'deg)';
        if (readout)  readout.textContent = yearValue ? yearValue + ' · ' + key : key;

        if (trine) {
          var a = idx, b = (idx + 4) % 12, c = (idx + 8) % 12, ra = 36;
          var pa = dlZodiacPol(a * 30, ra), pb = dlZodiacPol(b * 30, ra), pc = dlZodiacPol(c * 30, ra);
          trine.setAttribute('points', pa.x + ',' + pa.y + ' ' + pb.x + ',' + pb.y + ' ' + pc.x + ',' + pc.y);
        }
        if (clash) {
          var d = (idx + 6) % 12, rd = 36;
          var pd = dlZodiacPol(d * 30, rd), p0 = dlZodiacPol(idx * 30, rd);
          clash.setAttribute('x1', p0.x); clash.setAttribute('y1', p0.y);
          clash.setAttribute('x2', pd.x); clash.setAttribute('y2', pd.y);
        }
        if (wheel) wheel.classList.add('is-active');

        if (!opts || opts.persist !== false) persistKey(key);
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () { activate(btn.getAttribute('data-zodiac-key'), null); });
      });

      if (yearInput) {
        yearInput.addEventListener('input', function () {
          var year = parseInt(yearInput.value, 10);
          if (!year || year < 1900 || year > 2100) { if (readout) readout.textContent = '—'; return; }
          activate(dlZodiacYearToKey(year), year);
        });
      }

      /* preselect: reading state birth year → stored key → default.
         Read dl_reading_state directly from localStorage — donglai-quiz.js
         (which exposes window.DLQuiz) is only loaded on the reading page. */
      var birthYear = null;
      try {
        var raw = localStorage.getItem('dl_reading_state');
        if (raw) {
          var saved = JSON.parse(raw);
          var m = saved && typeof saved.date === 'string'
            ? saved.date.match(/^(\d{4})-\d{2}-\d{2}$/) : null;
          if (m) birthYear = parseInt(m[1], 10);
        }
      } catch (_) {}

      /* ?sign=<key> — the mega-menu zodiac grid links here. An explicit click
         outranks the whole chain above: it's a deliberate choice made this
         moment, where the birth year and the stored key are both inferred
         from earlier visits. Ignored unless it names a real sign, so a junk
         query string falls through to the normal preselect. */
      var paramKey = null;
      try {
        var qs = new URLSearchParams(window.location.search).get('sign');
        if (qs && DL_ZODIAC_DATA.some(function (z) { return z.key === qs; })) paramKey = qs;
      } catch (_) {}

      var initialKey = paramKey
        || (birthYear ? dlZodiacYearToKey(birthYear) : null)
        || getStoredKey()
        || defaultKey;

      /* When the link picked the sign, the stored birth year no longer
         describes it — don't caption the wheel "1994 · dog". */
      var initialYear = paramKey ? null : birthYear;
      activate(initialKey, initialYear);

      if (initialYear && yearInput) {
        yearInput.value = initialYear;
        if (readout) readout.textContent = initialYear + ' · ' + initialKey;
      } else if (!yearInput || !yearInput.value) {
        var z2026 = dlZodiacYearToKey(2026);
        if (readout) readout.innerHTML = '<span style="opacity:.55">2026 · ' + z2026 + '</span>';
      }

      /* Live sync with the wuxing reading wizard on the same page. */
      document.addEventListener('dl:reading-complete', function (e) {
        var year = e.detail && e.detail.birthYear;
        if (!year) return;
        if (yearInput) yearInput.value = year;
        activate(dlZodiacYearToKey(year), year);
      });

      document.addEventListener('dl:reading-cleared', function () {
        if (yearInput) yearInput.value = '';
        if (readout) readout.textContent = '—';
        activate(defaultKey, null, { persist: false });
      });
    });
  }

  /* ---------- hero background slideshow ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('.dl-hero[data-dl-hero-rotate]').forEach(function (hero) {
      if (hero.dataset.dlHeroReady === '1') return;
      hero.dataset.dlHeroReady = '1';

      var slides = hero.querySelectorAll('.dl-hero__slide');
      if (slides.length < 2) return;

      /* honour reduced-motion: leave the first slide showing, don't cycle */
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var seconds = parseFloat(hero.dataset.dlHeroRotate) || 6;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, seconds * 1000);
    });
  }

  /* ---------- collection-tile background rotators ---------- */
  function initTileRotators(root) {
    (root || document).querySelectorAll('[data-dl-tile-rotate]').forEach(function (media) {
      if (media.dataset.dlTileReady === '1') return;
      media.dataset.dlTileReady = '1';

      var slides = media.querySelectorAll('.dl-tile__slide');
      if (slides.length < 2) return;

      /* honour reduced-motion: leave the first slide showing, don't cycle */
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var seconds = parseFloat(media.dataset.dlTileRotate) || 6;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, seconds * 1000);
    });
  }

  /* ---------- collection-archive horizontal carousel ---------- */
  function initShopCarousel(root) {
    (root || document).querySelectorAll('[data-dl-shop-carousel]').forEach(function (car) {
      if (car.dataset.dlShopReady === '1') return;
      car.dataset.dlShopReady = '1';

      var track = car.querySelector('[data-dl-shop-track]');
      var prev = car.querySelector('[data-dl-shop-prev]');
      var next = car.querySelector('[data-dl-shop-next]');
      /* arrows always render — sync() decides whether they're usable */
      if (!track || !prev || !next) return;

      /* one card + gap per click, so rows stay aligned to a column */
      function step() {
        var card = track.querySelector('.dl-pcard');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
        return card.getBoundingClientRect().width + gap;
      }

      function scrollByCard(dir) {
        /* 'auto' defers to the CSS scroll-behavior, so say 'instant' outright */
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: dir * step(), behavior: reduced ? 'instant' : 'smooth' });
      }

      function sync() {
        /* Cards-in-view is a CSS media-query value (2.2 <=900px, 1.4 <=600px),
           so whether this row overflows changes with the viewport — a row that
           fits on desktop still scrolls on a phone. max <= 1 means it fits
           right now: disable both, which the stylesheet draws as opacity:0 /
           pointer-events:none. The resize listener re-runs this on breakpoint
           changes. */
        var max = track.scrollWidth - track.clientWidth;
        var fits = max <= 1;
        prev.disabled = fits || track.scrollLeft <= 1;
        next.disabled = fits || track.scrollLeft >= max - 1;
      }

      prev.addEventListener('click', function () { scrollByCard(-1); });
      next.addEventListener('click', function () { scrollByCard(1); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- bootstrap ---------- */
  function init() {
    observeReveals(document);
    initBracelets(document);
    initWuxing(document);
    initZodiacLuopan(document);
    initHero(document);
    initTileRotators(document);
    initShopCarousel(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run behaviours when Shopify theme editor injects a section */
  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target);
    initBracelets(e.target);
    initWuxing(e.target);
    initZodiacLuopan(e.target);
    initHero(e.target);
    initTileRotators(e.target);
    initShopCarousel(e.target);
  });

  window.Donglai = {
    observeReveals: observeReveals,
    initBracelets: initBracelets,
    initWuxing: initWuxing,
    initZodiacLuopan: initZodiacLuopan,
    initHero: initHero,
    initTileRotators: initTileRotators,
    initShopCarousel: initShopCarousel
  };
})();

/* ============================================================
   Donglai Header · scroll shadow + mobile drawer
   ============================================================ */
(function () {
  'use strict';

  function initHeader(root) {
    var header = (root || document).querySelector('.dl-header');
    if (!header) return;
    if (header.dataset.dlHeaderReady === '1') return;
    header.dataset.dlHeaderReady = '1';

    var sectionId      = header.id.replace('dl-header-', '');
    var drawer         = document.getElementById('dl-header-drawer-' + sectionId);
    var overlay        = document.querySelector('.dl-header__overlay');
    var hamburger      = header.querySelector('.dl-header__hamburger');
    var closeBtn       = drawer ? drawer.querySelector('.dl-header__drawer-close') : null;
    var mobileMega     = drawer ? drawer.querySelector('.dl-mega-mobile') : null;
    var collectionsBtn = drawer ? drawer.querySelector('[data-drawer-drill="collections"]') : null;
    var mobileBack     = mobileMega ? mobileMega.querySelector('[data-drawer-back]') : null;

    /* scroll shadow (also drives the homepage transparent→solid header).
       60px keeps the header transparent while the top of the hero is in
       view, then flips it to the solid cream bar. On non-home pages this
       only delays the drop shadow ~50px — harmless. */
    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('dl-header--scrolled');
      } else {
        header.classList.remove('dl-header--scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* mobile drawer */
    function closeMobileMega() {
      if (!mobileMega) return;
      mobileMega.classList.remove('is-open');
      mobileMega.setAttribute('aria-hidden', 'true');
      collectionsBtn && collectionsBtn.setAttribute('aria-expanded', 'false');
    }
    function openDrawer() {
      if (!drawer || !overlay) return;
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('active');
      hamburger && hamburger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('dl-scroll-locked');
      closeBtn && closeBtn.focus();
    }
    function closeDrawer() {
      if (!drawer || !overlay) return;
      closeMobileMega();
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('active');
      hamburger && hamburger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('dl-scroll-locked');
      hamburger && hamburger.focus();
    }

    hamburger && hamburger.addEventListener('click', openDrawer);
    closeBtn  && closeBtn.addEventListener('click', closeDrawer);
    overlay   && overlay.addEventListener('click', closeDrawer);

    /* mobile drill-down */
    if (collectionsBtn && mobileMega) {
      collectionsBtn.addEventListener('click', function () {
        mobileMega.classList.add('is-open');
        mobileMega.setAttribute('aria-hidden', 'false');
        collectionsBtn.setAttribute('aria-expanded', 'true');
      });
      mobileBack && mobileBack.addEventListener('click', closeMobileMega);
    }

    /* Drawer accordions (element list, zodiac grid). Stacked vertically these
       two groups ran to ~1400px, so they collapse and only one opens at a time
       — closing the others is what keeps the drawer short no matter what gets
       added later. Destiny and "shop all" are plain links, not accordions.
       `hidden` is toggled rather than animating a height: it keeps the closed
       content out of the a11y tree, and there's no reflow jank on cheap phones. */
    var accs = mobileMega ? mobileMega.querySelectorAll('[data-dl-acc]') : [];
    Array.prototype.forEach.call(accs, function (acc) {
      var btn = acc.querySelector('[data-dl-acc-btn]');
      var panel = acc.querySelector('[data-dl-acc-panel]');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var willOpen = btn.getAttribute('aria-expanded') !== 'true';

        Array.prototype.forEach.call(accs, function (other) {
          var oBtn = other.querySelector('[data-dl-acc-btn]');
          var oPanel = other.querySelector('[data-dl-acc-panel]');
          if (!oBtn || !oPanel) return;
          var open = willOpen && other === acc;
          oBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          oPanel.hidden = !open;
          other.classList.toggle('is-open', open);
        });

        /* Reopening further down the drawer would otherwise leave the header
           you just tapped scrolled off the top. */
        if (willOpen && typeof btn.scrollIntoView === 'function') {
          btn.scrollIntoView({ block: 'nearest' });
        }
      });
    });

    /* Leaving the sub-view resets the accordions, so coming back always starts
       from the calm three-row state rather than wherever you left it. */
    if (mobileBack) {
      mobileBack.addEventListener('click', function () {
        Array.prototype.forEach.call(accs, function (acc) {
          var btn = acc.querySelector('[data-dl-acc-btn]');
          var panel = acc.querySelector('[data-dl-acc-panel]');
          if (!btn || !panel) return;
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
          acc.classList.remove('is-open');
        });
      });
    }

    /* mega-menu (desktop hover + keyboard) */
    var trigger    = header.querySelector('[data-mega-trigger]');
    var panel      = document.getElementById('dl-mega-' + sectionId);
    var openTimer, closeTimer;

    function openMega() {
      if (!trigger || !panel) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }, 120);
    }
    function closeMega() {
      if (!trigger || !panel) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }, 200);
    }

    if (trigger && panel) {
      trigger.addEventListener('mouseenter', openMega);
      trigger.addEventListener('mouseleave', closeMega);
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', closeMega);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          openMega();
          setTimeout(function () {
            var first = panel.querySelector('a, button');
            if (first) first.focus();
          }, 140);
        }
      });
    }

    /* close drawer + mega on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (panel && panel.classList.contains('is-open')) {
          closeMega();
          trigger && trigger.focus();
        } else {
          closeDrawer();
        }
      }
    });
  }

  /* initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeader(); });
  } else {
    initHeader();
  }

  /* theme editor re-render */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.dl-header')) initHeader(e.target);
  });
})();
